import { render, staticRenderFns } from "./backoffice-autorizacao.vue?vue&type=template&id=4d0c95e0&scoped=true"
import script from "./backoffice-autorizacao.vue?vue&type=script&lang=ts"
export * from "./backoffice-autorizacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0c95e0",
  null
  
)

export default component.exports